import { Stack, Typography } from '@mui/material';

import { AlgorithmsStatus } from '../../types';

interface AlgorithmLevelCellProps {
  algorithmsStatus: AlgorithmsStatus[];
}

const AlgorithmLevelCell = ({ algorithmsStatus }: AlgorithmLevelCellProps) => {
  if (!algorithmsStatus.length) {
    return (
      <Typography
        variant='subtitleNumbers'
        component='span'
        color='textSecondary'
      >
        N/A
      </Typography>
    );
  }

  return (
    <Stack gap={2}>
      {algorithmsStatus.map(({ id, level }) => (
        <Typography
          variant='subtitleNumbers'
          color='textTertiary'
          component='span'
          key={id}
        >
          {level}
        </Typography>
      ))}
    </Stack>
  );
};

export default AlgorithmLevelCell;
